import {h, Fragment} from "preact"
import { useAppStateSelector, useProductFilters } from "@nosto/preact"
import { useMemo, useEffect, useRef } from "preact/hooks"
import { searchProductCountEl, fetchSearchTotal } from "../helpers"
import { variantFilterMatch } from "../config"

import Product from "./Product"

export default function Products() {
  const { products, loading, pageType, query } = useAppStateSelector((state) => ({
    products: state.response.products,
    loading: state.loading,
    pageType: state.pageType,
    query: state.query,
  }))
  const { filters } = useProductFilters()

  const activeFilters = useMemo(() => {
    return (
      filters
        .filter((f) => variantFilterMatch.some((field) => field.filterField === f.field))
        .reverse() || []
    )
  }, [filters])

  const lastQuery = useRef(null)

  useEffect(() => {
    if (
      pageType !== "search" ||
      !searchProductCountEl ||
      !query?.query ||
      lastQuery?.current === query.query
    )
      return

    lastQuery.current = query.query

    const fetchTotal = async () => {
      const unfilteredTotal = await fetchSearchTotal(query.query)
      searchProductCountEl.textContent = `Products (${unfilteredTotal ?? 0})`
      document.title = `Search: ${unfilteredTotal ?? 0} results found for "${query.query}"`
    }

    fetchTotal()
  }, [pageType, query?.query])

  const inGridItems = useMemo(() => {
    const el = document.getElementById("collection-in-grid-content")
    if (!el?.textContent) return null
    try {
      return JSON.parse(el.textContent)
    } catch {
      return null
    }
  }, [])

  return (
    <div
      id="nosto-product-grid-container"
      class="group/grid flex-1"
      style={{ opacity: loading ? 0.3 : 1 }}
    >
      <div>
        <ul class="grid grid-cols-2 group-aria-expanded/grid:grid-cols-1 gap-[10px] lg:grid-cols-3 lg:group-aria-expanded/grid:grid-cols-3">
          {products.hits.map((hit, index) => (
            <Product
              key={hit.productId || index}
              product={hit}
              activeFilters={activeFilters}
            />
          ))}

          {inGridItems && filters.length === 0
            ? inGridItems.map((item, index) => {
                return (
                  <ingrid-item
                    key={item.id || index}
                    index={index}
                    data-item={JSON.stringify(item)}
                  />
                )
              })
            : null}
        </ul>
      </div>
    </div>
  )
}